import React from "react";
import { connect } from "react-redux";
import {
  Transition,
  Container,
  Header,
  Segment,
  Button
} from "semantic-ui-react";
import ActividadForm from "./shared/actividades/ActividadForm";
import { actividadesOps } from "../ducks/actividades";

class NuevaActividad extends React.Component {
  state = { visible: false };

  componentDidMount() {
    this.setState({ visible: true });
  }

  handleVolver = () => this.props.history.goBack();

  render() {
    return (
      <Transition.Group animation="scale" duration={250}>
        {this.state.visible && (
          <Container>
            <Segment basic>
              <Segment basic>
                <Button
                  content="Cerrar"
                  floated="right"
                  color="pink"
                  icon="cancel"
                  onClick={this.handleVolver}
                />
                <Header inverted as="h2" textAlign="center">
                  Nueva Actividad
                </Header>
              </Segment>

              <ActividadForm action={this.props.saveDataActividad} />
            </Segment>
          </Container>
        )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = state => ({});

const actions = {
  saveDataActividad: actividadesOps.saveDataActividad
};

export default connect(mapStateToProps, actions)(NuevaActividad);



// WEBPACK FOOTER //
// ./src/pages/NuevaActividad.jsx